import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { NYCPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "How does TekRevol differentiate itself in the New York City app development market?",
    answer: `<p>TekRevol stands out through advanced solutions, international credibility, and novel approaches. We utilise leading-edge technology and intuitive layouts to craft seamless user experiences. Our AI-driven automation modernises business operations effectively.</p>`,
  },
  {
    question:
      "How do you ensure compliance with local regulations and customer preferences in New York?",
    answer: `<p>We prioritise local compliance and user choices by holding extensive market research explicit to NYC. Our apps align with local regulations and cover the diverse choices of the New York audience. Regular feedback sessions with clients enable us to refine our solutions further.</p>`,
  },
  {
    question: "What type of apps are most profitable in NYC?",
    answer: ` <p>App profitability depends on strategy and objectives. Given the thriving gaming industry to yield high returns. TekRevol specializes in game app development, creating visually stunning games with premium features that align with current gaming trends.</p>`,
  },
  {
    question: "How long does it take to complete an application?",
    answer: `<p>The estimated completion time for an application typically falls within the 3-5 week range. However, this timeline may extend in cases where the application involves complex development processes.</p>`,
  },
  {
    question: "How much does app development cost in NYC?",
    answer: ` <p>The average cost of app design and development depends on the type of application, the complexity of features, and the platform requirements. On average, a simple app with basic features can cost anywhere from $5,000 to $20,000. More complex apps with advanced functionalities, extensive API integrations, and customized features may range from $20,000 to $100,000 or more. However you can use our <Link to='/app-cost-calculator' rel='noopener' aria-label='TekRevol'>cost calculator</Link> to get an estimate.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{NYCPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
